module.exports = __webpack_public_path__ + "img/66.a6e735d1.jpg";